import React from "react";
import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import SFSwitch from "../../toggleSwitch";
import { useTranslation } from "react-i18next";
import SFTypography from "../../typography";

const SwitchRenderer = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
  errors,
}) => {
  const onChange = (e) => {
    const value = e.target.checked;
    handleChange(path, value);
  };
  const { t } = useTranslation();
  return (
    <>
      <SFTypography variant="tableListDescription">
        {t(uischema.i18nKey)}
      </SFTypography>
      <SFSwitch
        checked={data}
        rightLabel={
          data
            ? t(uischema.enabledi18nKey)
            : t(uischema.disabledi18nKey)
        }
        onChange={onChange}
      />
    </>
  );
};

export const SwitchTester = rankWith(
  166,
  schemaMatches((schema) => schema.switch === true)
);

export default withJsonFormsControlProps(SwitchRenderer);
